import React from 'react';
import styled from 'styled-components';
import { colors } from '../styles';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';

const LandingPage = () => {
  const navigate = useNavigate();
  const { user, userProfile } = useAuth();
  const toast = useToast();
  
  const handleBoardClick = () => {
    if (user && userProfile?.username) {
      navigate(`/${userProfile.username}/board`);
    } else if (user) {
      toast.showToast('Por favor, completa tu perfil primero', 'error');
      navigate('/profile');
    } else {
      navigate('/login');
    }
  };

  return (
    <Container>
      <Hero>
        <Title>Vision Board</Title>
        <Subtitle>Visualiza tus sueños, alcanza tus metas</Subtitle>
        <Description>
          Crea tu propio tablero de visión digital y compártelo con el mundo.
          Organiza tus metas, sueños y aspiraciones de una manera visual y motivadora.
        </Description>
        {user ? (
          <CTAButton onClick={handleBoardClick}>
            {userProfile?.username ? 'Ver mi Vision Board' : 'Completar Perfil'}
          </CTAButton>
        ) : (
          <ButtonGroup>
            <CTAButton onClick={() => navigate('/login')}>
              Comenzar Ahora
            </CTAButton>
            <SecondaryButton onClick={() => navigate('/explore')}>
              Explorar Boards
            </SecondaryButton>
          </ButtonGroup>
        )}
      </Hero>
      <Features>
        <Feature>
          <FeatureTitle>✨ Personalizable</FeatureTitle>
          <FeatureText>Crea un board que refleje tu estilo único</FeatureText>
        </Feature>
        <Feature>
          <FeatureTitle>🌍 Compartible</FeatureTitle>
          <FeatureText>Comparte tus sueños o mantelos privados</FeatureText>
        </Feature>
        <Feature>
          <FeatureTitle>🎯 Enfocado</FeatureTitle>
          <FeatureText>Mantén tus metas siempre visibles</FeatureText>
        </Feature>
      </Features>
    </Container>
  );
};

const Container = styled.div`
  min-height: calc(100vh - 80px);
  padding: 2rem;
  background-color: ${colors.primary};
`;

const Hero = styled.div`
  text-align: center;
  max-width: 800px;
  margin: 4rem auto;
  padding: 2rem;
`;

const Title = styled.h1`
  font-family: 'Caveat', cursive;
  font-size: 4rem;
  color: ${colors.text};
  margin-bottom: 1rem;
`;

const Subtitle = styled.h2`
  font-family: 'Indie Flower', cursive;
  font-size: 2rem;
  color: ${colors.accent};
  margin-bottom: 2rem;
`;

const Description = styled.p`
  font-family: 'Indie Flower', cursive;
  font-size: 1.2rem;
  color: ${colors.text};
  line-height: 1.6;
  margin-bottom: 3rem;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

const CTAButton = styled.button`
  height: auto;
  padding: 1rem 2rem;
  font-size: 1.2rem;
  font-family: 'Indie Flower', cursive;
  background-color: ${colors.secondary};
  border: none;
  color: ${colors.white};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${colors.accent};
    transform: translateY(-2px);
  }
`;

const SecondaryButton = styled(CTAButton)`
  background-color: transparent;
  border: 2px solid ${colors.secondary};
  color: ${colors.secondary};

  &:hover {
    background-color: ${colors.secondary}10;
    border-color: ${colors.accent};
    color: ${colors.accent};
  }
`;

const Features = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 4rem auto;
`;

const Feature = styled.div`
  text-align: center;
  padding: 2rem;
  background-color: ${colors.white};
  border-radius: 8px;
  box-shadow: 0 4px 12px ${colors.shadow};
`;

const FeatureTitle = styled.h3`
  font-family: 'Caveat', cursive;
  font-size: 1.8rem;
  color: ${colors.text};
  margin-bottom: 1rem;
`;

const FeatureText = styled.p`
  font-family: 'Indie Flower', cursive;
  font-size: 1.1rem;
  color: ${colors.text};
`;

export default LandingPage; 